export function generateAccountLink(): string {
  return window.Silverfin.Routes.ledger_consolidations_account_links_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    window.Silverfin.currentLedgerId()
  )
}
